import { type ComponentPropsWithoutRef, memo } from 'react';

import { type PublicClip } from '@air/api';
import { Tooltip } from '@air/primitive-tooltip';
import { type Clip } from '@air/types';
import { cn } from '@air/utils-tailwind';

export type GalleryAssetTitleProps = Omit<ComponentPropsWithoutRef<'button'>, 'children'> & {
  clip: Clip | PublicClip;
};

export const GalleryAssetTitle = memo(({ className, clip, ...restOfProps }: GalleryAssetTitleProps) => {
  const title = clip.title || clip.importedName || 'Untitled';

  return (
    <Tooltip label={title} side="top" sideOffset={4}>
      <button
        data-testid="ASSET_CARD_TITLE"
        className={cn(
          'pointer-events-auto truncate text-left font-medium text-16 text-grey-12 outline-none hover:underline focus-visible:ring-2 focus-visible:ring-blue-9',
          className,
        )}
        {...restOfProps}
      >
        {title}
      </button>
    </Tooltip>
  );
});

GalleryAssetTitle.displayName = 'GalleryAssetTitle';
